import { message, Upload } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { MdOutlineFileUpload } from 'react-icons/md'
import { REQUEST_EVENT_UPLOAD_URL } from '../../../config/urls';
import { API_ENDPOINT } from '../../../config/api';
import axios from 'axios';

export default function UploadFiles(props) {
    const { multiple, readOnly, onChange, value, setting } = props;
    const { max, size, accept, listType } = setting || {};
    const [filesList, setFilesList] = useState([]);

    useEffect(() => {
        setFilesList(value || [])
    }, [value])

    const beforeUpload = (file) => {
        if (accept) {
            if (!accept.includes(file.type)) {
                message.error('Only ' + accept + ' files are allowed!');
                return Upload.LIST_IGNORE;
            }
        }

        if (size) {
            const isLt5M = file.size < size;
            if (!isLt5M) {
                message.error('Image must be smaller than ' + (size / 1024 / 1024) + 'MB!');
                return Upload.LIST_IGNORE;
            }
        }


        if (max && value?.length >= max) {
            message.error('You can only upload up to ' + max + ' images.');
            return Upload.LIST_IGNORE;
        }

        return true;
    };

    // Function to handle file upload change event (success, error, or progress)
    const handleUploadChange = (info) => {
        const { file, fileList: newFileList } = info;

        if (file.status === 'removed' && !readOnly) {
            let newFile = [];
            newFile = value.filter((item) => item.uid !== file.uid);
            onChange([...newFile]);
            setFilesList([...newFile]);
        }

        if (file.status === 'uploading' && !readOnly) {
            onChange(newFileList);
            setFilesList(newFileList);
        }

        if (file.status === 'done') {
            const responseData = file.response;
            if (responseData?.result) {
                const updatedFileList = newFileList.map((item) => {
                    if (item.uid === file.uid) {
                        return {
                            ...item,
                            status: 'done',
                            url: responseData?.url,
                        };
                    }
                    return item;
                });

                onChange(updatedFileList);
                setFilesList(updatedFileList);
                message.success(`${file.name} uploaded successfully.`);
            } else {
                const updatedFileList = newFileList.map((item) => {
                    if (item.uid === file.uid) {
                        return { ...item, status: 'error' };
                    }
                    return item;
                });

                onChange(updatedFileList);
                setFilesList(updatedFileList);
                message.error(`${file.name} is failed to upload.`);
            }
        } else if (file.status === 'error') {
            const updatedFileList = newFileList.map((item) => {
                if (item.uid === file.uid) {
                    return { ...item, status: 'error' };
                }
                return item;
            });

            onChange(updatedFileList);
            setFilesList(updatedFileList);
            message.error(`${file.name} is failed to upload.`);
        }
    };

    const handleUploadFile = async (fileName, filebase64, options) => {
        const { onSuccess, onError, file } = options;
        var param = {
            "filename": fileName,
            "fileAsset": filebase64,
            "type": file.type,
        }
        await axios.post(
            `${API_ENDPOINT}${REQUEST_EVENT_UPLOAD_URL}`, param)
            .then((res) => {
                if (res?.data?.result) {
                    onSuccess(res.data);
                } else {
                    onError(res.data);
                }
            })
            .catch((err) => {
                console.log(err);
                onError(err);
            })
    }

    const toBase64 = (options) => new Promise((resolve, reject) => {
        const { file } = options;
        const fileName = file.name;
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result
                .replace('data:', '')
                .replace(/^.+,/, '');

            handleUploadFile(fileName, base64String, options);
        };
        reader.readAsDataURL(file);
    });

    const supportText = useMemo(() => {
        return setting?.supportText || "Support for a single or bulk upload."
    }, [setting])

    return (
        <Upload.Dragger
            name="file"
            method='POST'
            customRequest={toBase64}
            className='dynamic-form-custom-upload'
            listType={listType || 'text'}
            accept={accept}
            maxCount={max}
            action={API_ENDPOINT + REQUEST_EVENT_UPLOAD_URL}
            multiple={multiple}
            disabled={readOnly}
            fileList={filesList}
            beforeUpload={beforeUpload}
            onChange={handleUploadChange}
        >
            <p className="ant-upload-drag-icon">
                <MdOutlineFileUpload />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">{supportText}</p>
        </Upload.Dragger>
    )
}
